import * as React from 'react';
import ReactDOM from 'react-dom';
import Slider from 'react-slick';

interface PromoItem {
    title: string;
    description: string;
    imgUrl: string;
}


interface Props {
    items: PromoItem[];
}

const PromoCarousel = (props: Props) => {

    const slickMobileSettings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false
    }

    return (
        <div className='promo-carousel'>
            <div className='promo-carousel__items desktop'>
                {
                    props.items.map(item => {
                        return (
                            <div className='promo-carousel__items__item'>
                                <div>
                                    <img src={item.imgUrl} className='promo-carousel__items__item__img' />
                                </div>
                                <div className='promo-carousel__items__item__title'>
                                    {item.title}
                                </div>
                                <div className='promo-carousel__items__item__description'>
                                    {item.description}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            
            <Slider {...slickMobileSettings} className='promo-carousel__items mobile'>
            {
                    props.items.map(item => {
                        return (
                            <div className='promo-carousel__items__item'>
                                <div>
                                    <img src={item.imgUrl} className='promo-carousel__items__item__img' />
                                </div>
                                <div className='promo-carousel__items__item__title'>
                                    {item.title}
                                </div>
                                <div className='promo-carousel__items__item__description'>
                                    {item.description}
                                </div>
                            </div>
                        )
                    })
                }
            </Slider>
        </div>
    )
}

export default function render() {
    const elements = document.getElementsByClassName('promo-carousel-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const children = Array.prototype.slice.call(element.children)
        const promoItems = children.map((child: HTMLDivElement) => {
            const item = {
                title: child.dataset.title || '' ,
                description: child.dataset.description || '',
                imgUrl: child.dataset.imageurl || ''
            }
            return item
        })
        return ReactDOM.render(
            <PromoCarousel items={promoItems}/>,
            element,
        );
    });
}
